module.exports = __webpack_public_path__ + "static/img/oilCompany.25345dc3.png";